module.exports = __webpack_public_path__ + "img/mono-square.6de3c0d3.svg";